import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export const Skel = ({ className = "" }) => <div className={`skeleton rounded-2xl ${className}`} />;

export function SectionHead({ eyebrow, title, sub, to, cta = "View all", testid }) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
        <h2 className="h2">{title}</h2>
        {sub && <p className="mt-2 max-w-xl text-sm text-[#78716C] md:text-base">{sub}</p>}
      </div>
      {to && (
        <Link to={to} data-testid={testid} className="hidden shrink-0 text-sm font-semibold text-[#6B1D2F] hover:text-[#D97706] sm:block">
          {cta} →
        </Link>
      )}
    </div>
  );
}

export function Empty({ icon = "🪔", title, sub, action }) {
  return (
    <div data-testid="empty-state" className="card temple-pattern flex flex-col items-center px-6 py-14 text-center">
      <div className="mb-3 text-4xl">{icon}</div>
      <p className="font-display text-xl font-semibold text-[#6B1D2F]">{title}</p>
      {sub && <p className="mt-1 max-w-sm text-sm text-[#78716C]">{sub}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function ErrorState({ msg, retry }) {
  return (
    <div data-testid="error-state" className="card flex flex-col items-center px-6 py-12 text-center">
      <p className="font-display text-lg text-[#6B1D2F]">Something went wrong</p>
      <p className="mt-1 text-sm text-[#78716C]">{msg}</p>
      {retry && <button onClick={retry} className="btn-ghost mt-4" data-testid="retry-btn">Try again</button>}
    </div>
  );
}

export function Img({ src, alt, className = "", ratio }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={`relative overflow-hidden bg-[#F3EDE2] ${ratio || ""} ${className}`}>
      {!loaded && <div className="skeleton absolute inset-0" />}
      <img src={src} alt={alt || ""} loading="lazy" decoding="async" onLoad={() => setLoaded(true)}
        className={`h-full w-full object-cover transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"}`} />
    </div>
  );
}

export function useInView(cb, deps = []) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    const io = new IntersectionObserver(([e]) => e.isIntersecting && cb(), { rootMargin: "400px" });
    io.observe(ref.current);
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return ref;
}

export const Avatar = ({ src, name, size = "h-9 w-9" }) =>
  src ? <img src={src} alt={name} loading="lazy" className={`${size} shrink-0 rounded-full object-cover ring-2 ring-[#FDF8E2]`} />
    : <div className={`${size} flex shrink-0 items-center justify-center rounded-full bg-[#FDF2F4] font-display font-bold text-[#6B1D2F]`}>{(name || "S")[0]}</div>;
